import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AccountingState } from './accounting.reducer';
import * as fromAccounting from './accounting.reducer';
import { AccountingQuery } from './accounting.actions';
import { LoadingState, getError } from 'app/utils/callstate';
import * as _ from 'lodash';

export const selectAccountingState = createFeatureSelector<AccountingState>('accounting');

export const selectAccounting = createSelector(
  selectAccountingState,
  fromAccounting.selectAll
);

export const selectAccountingByAccount = (account: string ) => createSelector(
  selectAccounting,
  entries => _.filter(entries, entry => entry.account === account)
);

export const selectAccountingByJournal = (journal: string ) => createSelector(
  selectAccounting,
  entries => _.filter(entries, entry => entry.journal === journal)
);

// TODO: Specify Rule for selectAccountingByCustomer (account 6 & match)
export const selectAccountingByCustomer = (key: string) => createSelector(
  selectAccounting,
  entries => _.filter(entries, entry => entry.journal === key)
);

// TODO: Specify Rule for selectAccountingByProvider (account 7 & match)
export const selectAccountingByProvider = (key: string) => createSelector(
  selectAccounting,
  entries => _.filter(entries, entry => entry.journal === key)
);


export const selectAccountingLoading = createSelector(
  selectAccountingState,
  accountingState => accountingState.callState === LoadingState.Loading
);

export const selectAccountingLoaded = createSelector(
  selectAccountingState,
  accountingState => accountingState.callState === LoadingState.Loaded
);

export const selectAccountingError = createSelector(
  selectAccountingState,
  accountingState => getError(accountingState.callState)
);


export const selectAccountingQuery = createSelector(
  selectAccountingState,
  accountingState => ({
    companyId: accountingState.companyId,
    key: accountingState.key,
    filter: accountingState.filter
  } as AccountingQuery)
);
